/* stylelint-disable */
import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const TooltipWrapper = styled.div`
  display: inline-block;

  @media ${breakpoints.medium} {
    position: relative;
  }
`;

export const TooltipLink = styled.div`
  color: #006aff;
  cursor: pointer;
  padding-left: 4px;
`;

export const TooltipPopupWrapper = styled.div`
  width: 100%;
  left: 0;
  right: 0;
  position: absolute;

  @media ${breakpoints.medium} {
    left: ${(props) => (props.leftPos ? `${props.leftPos}px` : 0)};
  }
`;

export const TooltipPopup = styled.div`
  color: #ffffff;
  font-family: 'Open Sans';
  font-size: 10px;
  letter-spacing: 0;
  line-height: 14px;

  box-sizing: border-box;
  width: 317px;
  border: 1px solid #ffffff;
  background-color: #30303b;
  padding: 10px;
  margin: 0 auto;
  z-index: 100;

  @media ${breakpoints.medium} {
    position: absolute;
    margin: 0;
  }
`;
